import { createStyles, makeStyles } from "@material-ui/core";
import { COLORS } from "../../../config/theme/theme";

const BUTTON_WIDTH = "212px";

export const userStyles = makeStyles(() =>
  createStyles({
    cardContainer: {
      margin: "10vh auto 0px auto",
      padding: 0,
      width: "calc(85vw)",
      border: "none",
      borderRadius: "12px",
      boxShadow: "0px 4px 30px rgba(0, 0, 0, 0.15)",
      "&:focus-visible": {
        border: "none",
        outline: "none",
      },
    },
    cardContentStyle: {
      margin: 0,
      padding: 0,
      "&:last-child": {
        margin: 0,
        padding: 0,
      },
    },
    gridContainerMain: {
      margin: 0,
      padding: "24px",
    },
    gridItemTitleDivStyle: {
      margin: "auto",
      padding: 0,
      textAlign: "left",
    },
    gridItemServiceableDivStyle: {
      margin: 0,
      padding: 0,
      display: "flex",
      justifyContent: "flex-end",
    },
    headerSpanStyle: {
      fontWeight: 700,
      fontSize: "20px",
      color: COLORS.MINE_SHAFT_LIGHT,
    },
    //
    configDetailsDiv: {
      padding: "0px 24px 24px 24px",
      margin: 0,
      maxHeight: "calc(82vh)",
      overflow: "auto",
    },
    accordionStyle: {
      background: COLORS.WHITE,
      border: "1px solid #C3C3C3",
      borderRadius: "4px",
      marginTop: "12px",
      "&:last-child": {
        padding: 0,
        margin: 0,
        marginTop: "12px",
      },
    },
    accordionSummaryStyle: {
      padding: "12px 24px 12px 12px",
    },
    accordionTitle: {
      fontSize: "18px",
      fontWeight: 600,
    },
    accordionDetailsStyle: {
      borderTop: "1px solid #C3C3C3",
      display: "block",
      padding: "12px",
    },
    marginAuto: {
      margin: "auto 0px",
    },
    configurationHeaderTextStyle: {
      fontWeight: 400,
      fontSize: "14px",
      color: COLORS.MINE_SHAFT_LIGHT,
      margin: "auto",
    },
    configurationValueTextStyle: {
      fontWeight: 500,
      fontSize: "14px",
      color: COLORS.MINE_SHAFT_LIGHT,
      margin: "auto",
    },
    configurationValueServiceTextStyle: {
      fontWeight: 600,
      fontSize: "14px",
      color: COLORS.DOS_BLUE_DARK,
      margin: "0px 0px 4px 0px",
    },
    configurationValueNonServiceTextStyle: {
      fontWeight: 600,
      fontSize: "14px",
      color: COLORS.FROLY,
      margin: "0px 0px 4px 0px",
    },
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    nonDataPresentCard: {
      margin: 0,
      padding: "8px",
      boxShadow: "none",
    },
    nonDataPresentCardContent: {
      padding: 0,
      margin: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "50px",
      fontSize: "14px",
      fontWeight: 400,
      color: COLORS.MINE_SHAFT,
      border: "1px solid",
      borderColor: COLORS.ATHENS_GRAY,
      borderRadius: "12px",
      background: COLORS.ATHENS_GRAY,
      "&:last-child": {
        padding: 0,
      },
    },
    nonDataPresentCardSpanStyle: {
      color: COLORS.FROLY,
      fontWeight: 500,
      fontSize: "14px",
    },
    // Footer
    gridContainerFooter: {
      margin: 0,
      padding: "24px 24px 16px 24px",
      display: "flex",
      justifyContent: "flex-end",
      boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.15)",
    },
    configurationGridHeaderItemStyle: {
      margin: "0px 0px 4px 0px",
      padding: 0,
    },
    tabsStyle: {
      borderBottom: `1px solid ${COLORS.SECONDARY_MAIN}`,
      backgroundColor: COLORS.SECONDARY_MAIN,
      maxHeight: "60px",
    },
    tabTextStyle: {
      fontWeight: 500,
      fontSize: "14px",
      color: COLORS.MINE_SHAFT_LIGHT,
      "&.MuiTab-root.Mui-selected": {
        color: COLORS.WHITE,
        backgroundColor: COLORS.DOS_BLUE_DARK,
        fontWeight: 600,
      }
    },
    configDetailsBox: {
      padding: "16px",
      margin: 0,
      maxHeight: "calc(80vh)",
      overflow: "auto",
    },
    configDetailsGridContainer: {
      margin: "8px 0px",
      padding: "8px",
      border: `1px solid ${COLORS.SECONDARY_DARK}`,
      borderRadius: "8px",
    },
    configDetailsGridItem: {
      margin: "auto 8px 16px 0px",
    },
    configurationTimeDetailsGridContainer: {
      margin: "4px 0px",
      padding: 0
    },
    linkStyle: {},
    iconButtonStyle: {
      padding: 0,
      margin: "auto 0px",
      "&:first-child": {
        margin: "auto 0px auto 0px",
      },
      "& + &": {  // Adjacent sibling: adds margin-left to the second icon if first is present
        margin: "auto 0px auto 16px",
      },
    },
    minimiseButtonStyle: {
      width: "30px",
      height: "30px",
      background: COLORS.WHITE,
      borderRadius: "4px",
      fill: COLORS.DOS_BLUE_DARK,
      textDecoration: "none",
      margin: "auto 0px",
      padding: "4px",
      border: "1px solid",
      borderColor: COLORS.DOS_BLUE_DARK,
    },
    minimizedContainer: {
      position: 'fixed',
      bottom: "24px",
      right: "24px",
      zIndex: 1300,
      cursor: 'pointer',
      padding: "24px",
      display: 'flex',
      alignItems: 'center',
      background: COLORS.PERSIAN_GREEN,
      border: "none",
      borderRadius: "12px",
      boxShadow: "24px",
      transition: 'transform 0.3s ease-in-out',
      '&:hover': {
        transform: 'scale(1.05)',
      },
    },
    minimizedTitle: {
      margin: "auto 0px",
      fontWeight: 600,
      fontSize: "14px",
      color: COLORS.WHITE,
    },
  })
);
